import ButtonSponsored from '../../buttonSponsored';
import './footerCardGlobal.sass';

/**
 * Muestra un botón de momios (apuesta) que redirige a la plataforma del patrocinador,
 * solo si existe información disponible en `metadata`.
 */
export default function FooterCardGlobal({ data, patrocinador }) {
  // Se obtiene la metadata específica del patrocinador
  const patrocinadorKey = patrocinador?.toLowerCase() || "";
  const metadata = data[`${patrocinadorKey}_metadata`] || {};

  return (
    <ButtonSponsored url ={metadata.url_mm_evento} buttonClass={"card-global__footer-momios"} wrapperClass={"card-global__footer"} patrocinador={patrocinador}/>
  )
}